import React from 'react'

import { useGroup } from 'redux/hooks/Groups'
import { useParams } from 'utils/hooks'
import { useTranslation } from 'language/translator'

import TasksKanbanBoard from 'components_new/organisms/tasks/TasksKanbanBoard'

import GroupTemplate from 'components_new/templates/GroupTemplate'

const GroupTasks = () => {
  const params = useParams<{ id: string }>()
  const group = useGroup(params.id)
  const { t } = useTranslation()

  if (!group) {
    return null
  }

  return (
    <GroupTemplate
      subpage={{ icon: { name: 'Tasks' }, title: t('tasks', 'tasks') }}
      variant="static"
    >
      <TasksKanbanBoard locked={{ groups: [group.id] }} />
    </GroupTemplate>
  )
}

export default GroupTasks
